export default "__VITE_ASSET__DggLzmcR__"